import { render } from "./PrintPriceTags.vue?vue&type=template&id=4b6b469c&scoped=true&ts=true"
import script from "./PrintPriceTags.vue?vue&type=script&lang=ts"
export * from "./PrintPriceTags.vue?vue&type=script&lang=ts"

import "./PrintPriceTags.vue?vue&type=style&index=0&id=4b6b469c&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b6b469c"]])

export default __exports__